var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8L20.9 19H18.745L17.544 16H13.454L12.255 19H10.101L14.5 8H16.5ZM8 0V2H14V4H12.032C11.2606 6.32208 10.0295 8.46502 8.412 10.301C9.1333 10.9446 9.91568 11.5163 10.748 12.008L9.997 13.886C8.92252 13.2766 7.9176 12.552 7 11.725C5.21358 13.3417 3.09804 14.5522 0.799 15.273L0.263 13.344C2.23284 12.7159 4.04802 11.6793 5.59 10.302C4.44869 9.00994 3.49806 7.56127 2.767 6H5.007C5.56435 7.02886 6.23267 7.9936 7 8.877C8.25011 7.4361 9.2353 5.7853 9.91 4.001L0 4V2H6V0H8ZM15.5 10.885L14.253 14H16.745L15.5 10.885Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/Translate.70ea24c768f559bc89b2b8eb499fc8f0.svg";
export { ForwardRef as ReactComponent };